// src/lib/countries.ts
import raw from "world-countries";

// Convert ISO alpha-2 -> flag emoji
export const codeToFlag = (code: string) =>
  code
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

export type Country = {
  code: string; // "US"
  name: string; // "United States"
  currency: string; // "USD"
  flag: string; // "🇺🇸"
};

export const COUNTRIES: Country[] = raw
  .map((c) => {
    const currency = Object.keys(c.currencies ?? {})[0] ?? "USD";
    return {
      code: c.cca2,
      name: c.name.common,
      currency,
      flag: codeToFlag(c.cca2),
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));

export const findCountry = (code?: string) =>
  (code && COUNTRIES.find((c) => c.code === code)) || undefined;
